<template>
    <Modal class="popup_content" v-model="newaddresshow" width="560" @on-cancel="newaddressCancel">
        <div slot="header" class="popup_header_content">
            <span>新增地址</span>
        </div>
        <div class="newaddress_popup_content">
            <div class="popup_head_body">
                <div class="newaddress_popup_box">
                    <Form ref="forminfo" :model="forminfo" :rules="ruleforminfo" :show-message="false" :label-width="130">
                        <FormItem label="公司名称：" prop="company">
                            <Input v-model="forminfo.company" placeholder="输入您的公司、店铺名称" style="width: 310px;" />
                        </FormItem>
                        <FormItem label="收货人：" prop="name">
                            <Input v-model="forminfo.name" placeholder="输入收货人姓名" style="width: 310px;" />
                        </FormItem>
                        <FormItem label="手机号码：" prop="phone">
                            <Input v-model="forminfo.phone" placeholder="输入收货人联系方式" :maxlength="11" style="width: 310px;" />
                        </FormItem>
                        <FormItem label="所在地区：" prop="citycode">
                            <Cascader :data="citylist" v-model="forminfo.citycode" :load-data="loadData" :clearable="false" placeholder="省-市-区/县" @on-change="cityChange" style="width: 310px;"></Cascader>
                        </FormItem>
                        <FormItem label="详细地址：" prop="address">
                            <Input v-model="forminfo.address" placeholder="填写详细地址，如小区、楼号、门牌号等" style="width: 310px;" />
                        </FormItem>
                        <FormItem prop="default" v-if="type == 1">
                            <Checkbox v-model="forminfo.default">设为默认地址</Checkbox>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <div slot="footer" class="popup_footer_content">
            <Button type="warning" size="large" @click="newaddressOk">提交</Button>
        </div>
    </Modal>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
export default {
    props: ['type', 'newaddresshows', 'addressinfo'],
    data() {
        const validatorPhone  = (rule, value, callback) => { // 验证手机号
            if (value === '' || isNaN(value) || value.length != 11) {
                callback(new Error(''))
            } else {
                callback()
            }
        }
        return {
            newaddresshow: false, // 弹窗是否显示
            forminfo: { // 表单信息
                company: '', // 公司名称
                name: '', // 收货人
                phone: '', // 手机号码
                citycode: [], // 省市区 code
                city: [], // 省市区 文字
                address: '', // 详细地址
                default: false, // 设为默认地址
            },
            ruleforminfo: { // 表单验证
                name: [
                    { required: true, message: '', trigger: 'blur' }
                ],
                phone: [
                    // { required: true, message: '', trigger: 'blur' }
                    { validator: validatorPhone, required: true, trigger: 'blur' }
                ],
                citycode: [
                    { required: true, type: 'array', min: 1, message: '', trigger: 'change' }
                ],
                address: [
                    { required: true, message: '', trigger: 'blur' }
                ],
            },
            citylist: [], // 城市列表
        }
    },
    methods: {
        getProvince () { // 获取省
            this.http.post(api.getprovince)
            .then(response => {
                for (var i = 0; i < response.data.msg.proLst.length; i++) {
                    response.data.msg.proLst[i].label = response.data.msg.proLst[i].name
                    response.data.msg.proLst[i].value = response.data.msg.proLst[i].id
                    response.data.msg.proLst[i].is_type = 0
                }
                this.citylist = response.data.msg.proLst
            })
            .catch(error => {
                console.log(error);
            })
        },
        getCity (item, callback) { // 获取市
            this.http.post(api.getcity, {adcode: item.id})
            .then(response => {
                for (var i = 0; i < response.data.msg.cityLst.length; i++) {
                    response.data.msg.cityLst[i].label = response.data.msg.cityLst[i].name
                    response.data.msg.cityLst[i].value = response.data.msg.cityLst[i].id
                    response.data.msg.cityLst[i].is_type = 1
                }
                item.children = response.data.msg.cityLst
                item.loading = false
                callback()
            })
            .catch(error => {
                console.log(error);
            })
        },
        getArea (item, callback) { // 获取区/县
            this.http.post(api.getarea, {adcode: item.id})
            .then(response => {
                for (var i = 0; i < response.data.msg.areaLst.length; i++) {
                    response.data.msg.areaLst[i].label = response.data.msg.areaLst[i].name
                    response.data.msg.areaLst[i].value = response.data.msg.areaLst[i].id
                }
                item.children = response.data.msg.areaLst
                item.loading = false
                callback()
            })
            .catch(error => {
                console.log(error);
            })
        },
        loadData (item, callback) { // 加载城市&地区
            item.loading = true
            item.is_type == 0 ? this.getCity(item, callback) : this.getArea(item, callback)
        },
        newaddressOk () { // 点击确定按钮
            let newinfo = deepClone(this.forminfo)
            this.$refs.forminfo.validate((valid) => {
                if (valid) {
                    this.$emit('newaddressOk', newinfo)
                    this.$refs.forminfo.resetFields()
                } else {
                    this.$Message.warning('请填写完整信息!')
                    // this.$refs.forminfo.resetFields()
                }
            })
        },
        newaddressCancel () { // 关闭弹窗
            this.$emit('newaddressCancel')
        },
        cityChange (value, selectedData) {
            this.forminfo.citycode = value
            this.forminfo.city = []
            for (var i = 0; i < selectedData.length; i++) {
                this.forminfo.city.push(selectedData[i].label)
            }
        },
    },
    watch: {
        newaddresshows () {
            this.newaddresshow = this.newaddresshows
        },
        addressinfo: {
            handler (val, oldVal) {
                if (val != '') {
                    console.log(this.addressinfo)
                    this.forminfo.company = this.addressinfo.shopname // 公司名
                    this.forminfo.name = this.addressinfo.contactname // 收货人
                    this.forminfo.phone = this.addressinfo.phone // 手机号码
                    if (this.addressinfo.adcodename != null) {
                        this.forminfo.citycode = [this.addressinfo.fathercode, this.addressinfo.cityadcode, this.addressinfo.adcode] // 省市区 - code
                        this.forminfo.city = [this.addressinfo.fathercodename, this.addressinfo.cityadcodename, this.addressinfo.adcodename] // 省市区 - 文字
                    } else if (this.addressinfo.cityadcodename != null) {
                        this.forminfo.citycode = [this.addressinfo.fathercode, this.addressinfo.cityadcode] // 省市区 - code
                        this.forminfo.city = [this.addressinfo.fathercodename, this.addressinfo.cityadcodename] // 省市区 - 文字
                    } else {
                        this.forminfo.citycode = [] // 省市区 - code
                        this.forminfo.city = [] // 省市区 - 文字
                    }
                    this.forminfo.address = this.addressinfo.detaddress // 详细地址
                    this.forminfo.default = this.addressinfo.is_main == 1 ? true : false // 详细地址
                } else {
                    this.forminfo.default = this.type == 1 ? false : true // 详细地址
                }
            },
            deep: true
        }
    },
    created () {
        this.getProvince()
    }
}

function deepClone (data) { // 深度拷贝
  var type = typeof(data)

  var obj
  if (type === 'array'||Array.isArray(data)) {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    //不再具有下一层次
    return data
  }
  if (type === 'array' ||Array.isArray(data)) {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}
</script>

<style scoped>

.newaddress_popup_box .ivu-form-item {
    margin-bottom: 20px;
}

.newaddress_popup_box .ivu-form-item:last-child {
    margin-bottom: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/component/popup/newaddress.vue